import { nothing } from 'maybeasy';
import { observer } from 'mobx-react';
import { emptyFragment } from '../../../../../../../../../../../../../../EmptyFragment';
import { Link } from '../../../../../../../../../../../../../../Resource/Types';
import { AlreadyTranslated, T } from '../../../../../../../../../../../../../../Translations';
import FlashMessage from '../../../../../../../../../../../../../FlashMessage';
import {
  filterGroups,
  filterParticipants,
  selectedParticipantCount,
} from '../../../../../../../../../../../Functions';
import ParticipantDynamicTypeaheadSelect from '../../../../../../../../../../../ParticipantDynamicTypeaheadSelect';
import { LearningCollectionPublishResource } from '../../../../../../../Store/Types';
import InviteParticipantStore from '../../../../Store';
import { SelectParticipantsState } from '../../../../Store/Types';
import ParticipantsList from '../ParticipantsList';
import { FilterOption } from '../../../../../../../../../../../ParticipantDynamicTypeaheadSelect/UseParticipantDynamicTypeaheadSelect/Types';

export interface Props {
  link: Link;
  store: InviteParticipantStore;
  learningCollectionPublishResource: LearningCollectionPublishResource;
  state: SelectParticipantsState;
}

const onChange = (store: InviteParticipantStore) => (option: FilterOption) => {
  option.payload.type.map((type) => {
    switch (type) {
      case 'participant':
        store.addParticipant(option);
        break;
      case 'group':
        store.addGroup(option);
        break;
    }
  });
};

function Body({ link, store, learningCollectionPublishResource, state }: Props) {
  return (
    <>
      {store.notification.map((alert) => <FlashMessage alert={alert} />).getOrElse(emptyFragment)}
      <label className="py-1.5 text-sm font-semibold text-gray-800 block">
        <T kind="Collection" />
      </label>
      <div className="flex flex-col mb-2">
        <select
          className="w-full bg-none rounded border-[#BEC0C580] bg-[#BEC0C580] opacity-50"
          disabled
          aria-label="Collection name"
        >
          <option>
            <AlreadyTranslated content={learningCollectionPublishResource.payload.name} />
          </option>
        </select>
      </div>
      <ParticipantDynamicTypeaheadSelect
        newGroups={filterGroups(state.newGroupsAndParticipants)}
        newParticipants={filterParticipants(state.newGroupsAndParticipants)}
        endpoint={link}
        name="participants"
        label="Select Participants or Groups"
        onChange={onChange(store)}
        initialValue={nothing()}
        labelClassname="py-1.5 text-sm font-semibold text-gray-800 block"
        placeholder="Enter Participant Name, Email or Group Name"
      />
      <div>
        <div className="font-semibold text-sm pt-4">
          <T
            kind="Participants to be added ({{count}} selected)"
            count={selectedParticipantCount(
              filterGroups(state.newGroupsAndParticipants),
              filterParticipants(state.newGroupsAndParticipants),
            )}
          />
        </div>
      </div>
      <ParticipantsList store={store} state={state} />
    </>
  );
}

export default observer(Body);
